import { gql } from '@apollo/client';

export const TranslationFragment = gql`
    fragment Translation on Translation {
        value
        locale
    }
`;
